module.exports = __webpack_public_path__ + "static/media/logo.a7956381.svg";